import {
  REQUEST_CARTAO_DESCONTOS, RECEIVE_CARTAO_DESCONTOS, RESET_ALL_CARTAO_DESCONTO, REQUEST_CARTAO_DESCONTOS_FATURAS, RECEIVE_CARTAO_DESCONTOS_FATURAS
} from '../constants/ActionTypes'

const INITIAL_STATE = {
  list: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 50,
    },
    receivedAt: null,
  },
  faturas: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 50,
    },
    receivedAt: null,
  },
}

export default function CartaoDescontoReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_CARTAO_DESCONTOS:
      return {
        ...state,
        list: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.list.data,
          receivedAt: state.list.receivedAt,
        }
      }
    case RECEIVE_CARTAO_DESCONTOS:
      return {
        ...state,
        list: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_CARTAO_DESCONTOS_FATURAS:
      return {
        ...state,
        faturas: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.faturas.data,
          receivedAt: state.faturas.receivedAt,
        }
      }
    case RECEIVE_CARTAO_DESCONTOS_FATURAS:
      return {
        ...state,
        faturas: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case RESET_ALL_CARTAO_DESCONTO:
      return INITIAL_STATE
    default:
      return state
  }
}
